/**
 * Viewport test, not a user-agent sniff: one generated file is served to every
 * device, so behaviour must follow the viewport. 1024px matches the `lg`
 * breakpoint the styles are written against.
 */
export default function isMobile() {
  return window.matchMedia('(max-width: 1023px)').matches;
}
